export const CONFIG_URLS = {
  REFERENCE_PLATFORM:
    'https://services2.arcgis.com/HlCEjEqEP9GdOQeZ/arcgis/rest/services/Reference_Platform_Species/FeatureServer/0',
} as any;
